import { gsap } from '../global/gsap';

const initMenu = (element) => {
    const body = document.querySelector('.js-body');
    const menuToggle = element.querySelectorAll('.js-menu-button');
    const navContainer = element.querySelector('.js-primary-nav-container');
    const navUpper = element.querySelector('.festial-nav__upper');
    const navItems = element.querySelectorAll('.primary-nav__upper-menu li');
    const bottomItems = element.querySelectorAll('.primary-nav__lower *');
    const stopScrollingClass = 'stop-scrolling';
    const isActiveClass = 'menu-active';
    let isActive = false;

    const menuTl = gsap.timeline();

    gsap.set(navUpper, {
        opacity: 0,
        yPercent: -25
    })

    gsap.set(navItems, {
        opacity: 0,
        yPercent: 50
    });

    gsap.set(bottomItems, {
        opacity: 0,
        yPercent: 50
    });

    menuTl.to(navContainer, { opacity: 1, duration: 0.75 });
    menuTl.add(() => {
        if (isActive) {
            navContainer.style.pointerEvents = 'all';
        } else {
            navContainer.style.pointerEvents = 'none';
        }
    });
    menuTl.to(navItems, { opacity: 1, yPercent: 0, stagger: 0.1, duration: 0.300 }, '-=.4');
    menuTl.to(bottomItems, { opacity: 1, yPercent: 0, stagger: 0.025, duration: 0.300 }, '-=.4');

    menuTl.pause();

    menuToggle.forEach((btn) => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            isActive = !isActive;

            if (isActive) {
                body.classList.add(stopScrollingClass, isActiveClass);
                menuTl.timeScale(1).play();
            } else {
                body.classList.remove(stopScrollingClass, isActiveClass);
                menuTl.timeScale(2).reverse();
            }
        });
    });
};

export { initMenu as default };
